import controller from "webforms/toggle.controller";
import templateUrl from "webforms/toggle.htm";

//http://ziscloud.github.io/angular-bootstrap-toggle/

export default () => ({
  restrict: "E",
  transclude: true,
  templateUrl,
  scope: {
    bindModel: "=ngModel"
  },
  require: ["toggle", "ngModel"],
  controller,
  controllerAs: "toggle",
  link: function(scope, element, attrs, ctrls) {
    var toggleCtrl = ctrls[0],
      ngModelCtrl = ctrls[1];
    toggleCtrl.element = element;
    toggleCtrl.init(ngModelCtrl);
  }
});
